import React from 'react';
import styled from 'styled-components';

export const Navbar = () => {
    const handleClick = () => {
        window.location.href="/";
    }

    return (
        <Container>
            <img src="/assets/Memories logo.png" alt="Memories Logo" onClick={handleClick}/>
        </Container>
    );
}

const Container = styled.nav`
    position: absolute;
    top: 0;
    width: 100%;
    padding: 1.25rem;

    img{
        cursor: pointer;
        display: block;
        margin: auto;
        width: 150px;
    }
`;